module.exports = __webpack_public_path__ + "static/media/postcard11thumb.7c115d79.jpg";